/** Pure helpers for the What's new walkthrough. */

/** sessionStorage key: the walkthrough opened by itself once this session. */
export function shownKey(userId: string): string {
  return `velora.whatsNew.shown.${userId}`;
}

/** Splits a step route (`/phones?tab=missed`) into a router target. In-app paths only. */
export function routeTarget(route: string): { to: string; search: Record<string, string> } {
  const [path = '/', query = ''] = route.split('?', 2);
  const to = path.startsWith('/') && !path.startsWith('//') ? path : '/';
  return { to, search: Object.fromEntries(new URLSearchParams(query)) };
}

/**
 * The user is busy: another dialog is open (Ctrl+K, a medical-alert popup,
 * the phone install sheet) or they are typing in a field. The automatic
 * "What's new" waits until neither is true (QA r57).
 */
export function userIsBusy(doc: Document = document): boolean {
  if (doc.querySelector('[role="dialog"], [role="alertdialog"]')) return true;
  const el = doc.activeElement as HTMLElement | null;
  if (!el) return false;
  return el.tagName === 'INPUT' || el.tagName === 'TEXTAREA' || el.isContentEditable === true;
}
